import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import ArrowPullSvg from 'src/app.feature/academy/component/icon/arrow-pull.svg';
import CategoryList from 'app.feature/academy/cbt.category/component/pc/CategoryList';
import CategoryButton from 'app.feature/academy/cbt.category/component/pc/CategoryButton';
import { useRecoilState } from 'recoil';
import { CategoryState } from '../../recoil/category';

interface CategoryProps {
  examType?: any;
  examList?: any;
}

const Category: React.FC<CategoryProps> = ({ examType, examList }) => {
  const router = useRouter();
  const [showAll, setShowAll] = useRecoilState(CategoryState);

  const handleToggleShowAll = () => {
    setShowAll((prevShowAll) => !prevShowAll);
  };

  useEffect(() => {
    setShowAll(false);
  }, [router]);

  const handleClickParentCategory = (id: number) => {
    router.push({
      query: {
        examTypeIds: id,
      },
    });
  };

  return (
    <>
      <CategoryWrapper>
        {(examType || [])?.map((category: any, index: number) => {
          const { id, name, url } = category;
          const filteredExamList = examList[index];
          return (
            <CategoryBox key={id}>
              <CategoryButton
                handleClickParentCategory={handleClickParentCategory}
                name={name}
                id={id}
              />
              <CategoryList examList={filteredExamList.nodes} showAll={showAll} />
            </CategoryBox>
          );
        })}
      </CategoryWrapper>
      <ButtonWrapper>
        <button
          className={`toggle-button ${showAll ? 'rotated' : ''}`}
          onClick={handleToggleShowAll}
        >
          <ArrowPullSvg />
        </button>
      </ButtonWrapper>
    </>
  );
};

export default Category;

const CategoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-top: 1px solid #ddd;
  border-bottom: 2px solid #666;
`;

const CategoryBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  border-bottom: 1px solid #ddd;

  &:last-child {
    border-bottom: none;
  }
`;

const ButtonWrapper = styled.div`
  text-align: center;

  .toggle-button {
    width: 31.5px;
    height: 17px;
    border: none;
    background-color: #888;
    color: #fff;
    text-align: center;
    border-radius: 0 0 3px 3px;

    &.rotated svg {
      transform: rotate(180deg);
      margin-top: 0;
      margin-bottom: 4px;
    }

    svg {
      transform: translateY(-50%);
      transition: transform 0.5s ease;
      transform-origin: center;
      margin-top: 5px;
    }
  }
`;
